module.exports = "<svg style=\"width: 16px; height: 14px\" viewBox=\"0 1 16 14\"><path d=\"M8,1 L0,5.611 L0,6.764 L3,8.493 L3,12.118 L8,15 L12.999,12.118 L12.999,8.493 L14,7.917 L14,12.179 L16,13.179 L16,5.611 L8,1 Z M3.004,6.188 L8,3.309 L12.996,6.188 L8,9.067 L3.004,6.188 Z M11,9.646 L11,10.963 L8,12.692 L5,10.963 L5,9.646 L8,11.375 L11,9.646 Z\" id=\"path-1\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./assets/icons/graduation-cap.svg
// module id = 167
// module chunks = 0